import type { FunctionComponent, } from "react";
import styled from "styled-components";
import { Typography, type Variant, } from "@bracket/ui";
import { getTokenDefinition, } from "@bracket/chainography";

import type {
	TokenIdentifier,
} from "@bracket/types";

//@ts-ignore - remove if props added
export declare type TokenAmountProps = {
	value: bigint;
	token: TokenIdentifier;
	symbol?: boolean;
	label?: boolean;
	precision?: number;
	variant?: Variant;
}


export const TokenAmount: FunctionComponent<TokenAmountProps> = ({
	value,
	token,
	symbol,
	label,
	precision = 5,
	variant = "p"
}) => {
	const tok = getTokenDefinition(token);
	const getValue = () => {
		if(typeof value === "bigint") {
			return [
				value !== BigInt(0) ? (Number(value) / Number(`1e${tok.decimals}`)).toFixed(precision) : "0",
				label ? tok.label : null,
				symbol ? tok.symbol : null,
			].filter(v => v).join(" ");
		}
		if(typeof value === "number") {
			return [
				Number(value).toFixed(precision),
				label ? tok.label : null,
				symbol ? tok.symbol : null
			].filter(v => v).join(" ");
		}
		return "Loading...";
	}

	return (
		<Typography variant={variant}>{getValue()}</Typography>
	);

}


const Brace = styled.span`

`
